export default "__VITE_ASSET__18866f76__"